import moment from 'moment';

export const convertDateTime = (value: moment.MomentInput) => {
  if (value) {
    return moment(value).format('DD.MM.YYYY HH:mm');
  } else {
    return null;
  }
};
